/**
 * Add same max height to the deeplinks tabs
 */
;
(function () {

    const $el = $('.js-m-modal--deeplink-height');
    if (!$el.length) return false;

    let group = '';

    $el.each(function () {
        if ($(this).data('tabsGroup') !== group) {
            group = $(this).data('tabsGroup');
            let height = 0;

            const $groupEl = $el.filter(function () {
                return $(this).data('tabsGroup') === group;
            });

            $groupEl.each(function () {
                $(this).css('display', 'block');

                if ($(this).height() > height) {
                    height = $(this).height();
                }

                $(this).css('display', '');
            });

            if (height > 0) {
                $groupEl.css('height', height + 50);
            }
        }
    });

})();